import React, { Fragment } from "react";
import { CheckedIcon, InfoCircleIcon } from "../../Resources/Icons/Collections";

const ImageTagSteps = props => {
	return (
		<Fragment>
			<div className="image-tag-guides">
				<div className="image-tag-guides-header">You must</div>
				{props.guides.map((guide, i) => (
					<div
						key={i}
						style={{ color: guide.showError ? "red" : "" }}
						className="image-tag-guides-list"
					>
						<span>
							{!guide.done ? (
								<InfoCircleIcon
									color={"rgba(181,181,181,1)"}
									height={"14px"}
									width={"14px"}
								/>
							) : (
								<CheckedIcon color={"#0dd471"} height={"14px"} width={"14px"} />
							)}
						</span>
						<span dangerouslySetInnerHTML={{ __html: guide.text }} />
					</div>
				))}
			</div>
		</Fragment>
	);
};

export default ImageTagSteps;
